import React from 'react';
import { Link } from 'react-router-dom';
export function Login() {
  return <div className="mt-8" data-id="element-291">
      <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-292">
        <h2 className="mb-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-293">
          Log in to your account
        </h2>
        <form className="space-y-6" action="#" method="POST" data-id="element-294">
          <div data-id="element-295">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-296">
              Email address
            </label>
            <div className="mt-1" data-id="element-297">
              <input id="email" name="email" type="email" autoComplete="email" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-298" />
            </div>
          </div>
          <div data-id="element-299">
            <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-300">
              Password
            </label>
            <div className="mt-1" data-id="element-301">
              <input id="password" name="password" type="password" autoComplete="current-password" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-302" />
            </div>
          </div>
          <div className="flex items-center justify-between" data-id="element-303">
            <div className="flex items-center" data-id="element-304">
              <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-305" />
              <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900" data-id="element-306">
                Remember me
              </label>
            </div>
            <div className="text-sm" data-id="element-307">
              <a href="#" className="font-medium text-blue-600 hover:text-blue-500" data-id="element-308">
                Forgot your password?
              </a>
            </div>
          </div>
          <div data-id="element-309">
            <Link to="/dashboard" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" data-id="element-310">
              Sign in
            </Link>
          </div>
        </form>
        <div className="mt-6" data-id="element-311">
          <div className="relative" data-id="element-312">
            <div className="absolute inset-0 flex items-center" data-id="element-313">
              <div className="w-full border-t border-gray-300" data-id="element-314" />
            </div>
            <div className="relative flex justify-center text-sm" data-id="element-315">
              <span className="px-2 bg-white text-gray-500" data-id="element-316">
                Or continue with
              </span>
            </div>
          </div>
          <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-317">
            <div data-id="element-318">
              <a href="#" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-319">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" data-id="element-320">
                  <path fillRule="evenodd" d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z" clipRule="evenodd" data-id="element-321" />
                </svg>
              </a>
            </div>
            <div data-id="element-322">
              <a href="#" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-323">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" data-id="element-324">
                  <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" data-id="element-325" />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="mt-6 text-center" data-id="element-326">
          <p className="text-sm text-gray-600" data-id="element-327">
            Don't have an account?{' '}
            <Link to="/register" className="font-medium text-blue-600 hover:text-blue-500" data-id="element-328">
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>;
}